import React, { useState, useEffect } from "react";
import "./contactpopup.css";
import { TextField, Button, IconButton, Typography } from "@mui/material";
import { Close, Person, Phone, Email } from "@mui/icons-material";
import img from "../../interior_assets/contactuss.jpeg";
import { useNavigate } from "react-router";
import ReCAPTCHA from "react-google-recaptcha";

const Contactpopup = ({ onClose }) => {

  const navigate = useNavigate();
  const [showForm, setShowForm] = useState(false);
  const [formData, setFormData] = useState({ fullName: "", email: "", phone: "", message: "" });
  const [status, setStatus] = useState(null);
  const [captchaVerified, setCaptchaVerified] = useState(false);
  const [ loading, setLoading] = useState(false);



  const handleCaptchaChange = (value) => {
    if (value) {
      setCaptchaVerified(true); // Set to true when CAPTCHA is verified
    } else {
      setCaptchaVerified(false); // Set to false if not verified
    }
  };

  useEffect(() => {
    setShowForm(true);
  }, []);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!captchaVerified) {
      setError("Please verify that you are not a robot.");
      return;
    }

    setLoading(true); // Start loading

    try {
      const response = await fetch("https://demo.firstskyinfra.in/php/model.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });

      const result = await response.json();
      // setStatus(result.message);
      if (result.status === "success") {
        navigate("/thank_you")
        setFormData({ fullName: "", email: "", phone: "", message: "" });
      }
    } catch (error) {
      setStatus("Something went wrong. Please try again.");
    } finally {
      setLoading(false); // Stop loading
    }
  };

  return (
    <div className="popup-overlay">
      <div className={`popup-container ${showForm ? 'show-form' : ''}`}>
        <div className="content-container">
          <div className="image-section">
            <img src={img} alt="showroom design" />
          </div>

          <div className="form-section">
            <div className="header-container">
              <Typography variant="h5" align="left">Contact Us</Typography>
              <IconButton className="close-btn-button" onClick={onClose}>
                <Close />
              </IconButton>
            </div>

            <form onSubmit={handleSubmit}>
              <TextField fullWidth label="Name" name="fullName" value={formData.name} onChange={handleChange} required size="small" InputProps={{ startAdornment: <Person /> }} />
              <TextField fullWidth label="Email" name="email" value={formData.email} onChange={handleChange} type="email" required size="small" InputProps={{ startAdornment: <Email /> }} />
              <TextField fullWidth label="Phone Number" name="phone" value={formData.phone} onChange={handleChange} type="tel" size="small" InputProps={{ startAdornment: <Phone /> }} />
              <TextField fullWidth label="Message" name="message" value={formData.message} onChange={handleChange} multiline rows={4} required size="small" />

              <ReCAPTCHA
                sitekey='6LeiptIqAAAAAKT6diIfDS8Wu3vU-4SEIYxA0yB3'
                // sitekey="6LcwRb4qAAAAAMq-olseDFdPgiJ4s48v3oLdfMIW"
                // sitekey="6LdyK74qAAAAAHior1ETtBZRJf6-78AZFgkPYKf3"
                //  // Replace with your reCAPTCHA site key
                onChange={handleCaptchaChange}
              />
              <div className="form-actions">
                <Button variant="contained" type="submit" color="primary"
                disabled={loading}>
                {loading ? "Sending..." : "Submit"}</Button>
                <Button variant="outlined" type="reset" color="secondary" onClick={() => setFormData({ fullName: "", email: "", phone: "", message: "" })}>Clear</Button>
              </div>
            </form>

            {status && <Typography variant="body2" color="error">{status}</Typography>}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contactpopup;
